import { defineComponent as _defineComponent } from 'vue'
import BasketSummaryLines from '@/ui/views/checkout/BasketSummaryLines.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.BasketViewModel;


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSummaryB2B',
  props: {
    basket: null,
    showVatText: { type: Boolean }
  },
  setup(__props: any) {




return { __sfc: true,BasketSummaryLines }
}

})